import React from 'react';
import { useQueryClient, useMutation } from '@tanstack/react-query';

import { FeedbackContext, LocalizationContext } from '@cvt/contexts';

import { cacheKeys } from '../config';
import { meetingClient } from '../client/meetingClient';


export const useMeetingCrud = () => {
  const { dictionary } = React.useContext(LocalizationContext);
  const { triggerFeedback, genericErrorFeedback } = React.useContext(FeedbackContext);
  const queryClient = useQueryClient();

  const createMeeting = useMutation({
    mutationKey: [cacheKeys.createMeeting],
    mutationFn: meetingClient.createMeeting,
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: [cacheKeys.getMeetings],
      });
      triggerFeedback({
        severity: 'success',
        message: dictionary.feedback.changesSaved,
      });
    },
    onError: () => {
      genericErrorFeedback();
    },
  });

  const editMeeting = useMutation({
    mutationKey: [cacheKeys.editMeeting],
    mutationFn: ({ id, ...data }: Partial<Meetings.Edit>) => meetingClient.editMeeting({ id, ...data }),
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: [cacheKeys.getMeetings],
      });
      queryClient.invalidateQueries({
        queryKey: [cacheKeys.getMeeting, data.data.id],
      });
      triggerFeedback({
        severity: 'success',
        message: dictionary.feedback.changesSaved,
      });
    },
    onError: () => {
      genericErrorFeedback();
    },
  });

  const deleteMeeting = useMutation({
    mutationKey: [cacheKeys.deleteMeeting],
    mutationFn: (id: number) => meetingClient.deleteMeeting({ id }),
    onSuccess: (data, id) => {
      queryClient.invalidateQueries({
        queryKey: [cacheKeys.getMeetings],
      });
      queryClient.removeQueries({
        queryKey: [cacheKeys.getMeeting, id],
      });

      triggerFeedback({
        severity: 'success',
        message: dictionary.feedback.changesSaved,
      });
    },
    onError: () => {
      genericErrorFeedback();
    },
  });

  return {
    createMeeting,
    editMeeting,
    deleteMeeting,
  };
};
